<script setup lang="ts">
import {API_URL, fetchJson} from "../ts/utils";
import {$t, ELO_LOCALES, getSelectedLocale, loadMessages, pickLocaleFrom, setLocale} from "../ts/translations";

let popup :WindowProxy|null = null;

function launchPopup()  {
  if(popup) {
    console.log('Closing popup')
    popup.close(); // Avoid multiple popups by accident, but close and reopen it to popup again "on top"
  }
  console.log('Opening popup')
  // EAUTH2-24
  // EAUTH2-197: add search parameters coming from a bookmark
  popup = window.open('./sign-in' + window.location.search, 'ELO Login', 'popup,height=604,width=480')
}

// EAUTH2-49: language choice comes from server and influenced by "ui_locales" parameter
await loadMessages()


// EAUTH2-250
// A missing `client_id` is a sign of a missing session.
// This is typically because of a bookmarked page.
// In that case, re-do the /authorize call.
const signInChoices = await fetchJson(API_URL + '/sign-in-choices')
if(!signInChoices.client_id && window.location.hash) {
  const base64urlHash = window.location.hash.substring(1)
  const base64hash = base64urlHash.replace(/-/g, '+').replace(/_/g, '/')
  const query = atob(base64hash)
  console.log(`Re-doing /authorize call with query: ${query}`)
  window.location.replace(`${API_URL}/authorize?${query}`)
}


// See welcome page, triggering this function
window["onPopupLoginSuccess"] = function() {
  // Once the user has signed in, redirect the IFrame to the original redirect URL
  console.log('Closing popup')
  popup.close()

  // EAUTH2-244: do not include /sign-in & /popup-launcher pages in browser history
  window.location.replace(API_URL + "/back-to-client");
}

// EAUTH2-44
// Usually, popups triggered directly "on load" are blocked by browsers and ad-blockers.
// That is why the page with the button exists, since popups triggered by "user interaction" are usually allowed.
// Nevertheless, if popups "on load" are enabled (usually by the user authorizing it), this will enable the popup to be launched directly.
launchPopup()

</script>

<template>
  <b-button type="is-dark" class="my-6" @click="launchPopup()" data-test-id="button-sign_in">{{$t('sign_in')}}</b-button>
  <p>{{$t('check_popup')}}</p>
</template>

<style scoped>

</style>
